module.exports = __webpack_public_path__ + "static/fonts/PingFangSCRegular.dbc8b753.woff";